export const cssProductDialogContainer = {
    "w-pc": {
        boxSizing: "border-box",
        position: "fixed",
        top: "0",
        left: "0",
        height: "100vh",
        width: "100%",
        paddingBlock: "15vh",
        paddingInline: "20vw",

        
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#9491915a",
    },
    "w-tab": {
        boxSizing: "border-box",
        position: "fixed",
        top: "0",
        left: "0",
        height: "100vh",
        width: "100%",
        paddingBlock: "31vh",
        paddingInline: "2vw",

        
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#9491915a",
    },
    "w-mob": {
        boxSizing: "border-box",
        position: "fixed",
        top: "0",
        left: "0",
        height: "100vh",
        width: "100%",
        paddingTop: "0Vh",
        paddingInline: "1vw",

        
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "end",

        backgroundColor: "#9491915a",
    }
} as any
export const cssProductDialogWrapper = {
    "w-pc": {
        boxSizing: "border-box",
        padding: "2%",
        height: "100%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"
    },
    "w-tab": {
        boxSizing: "border-box",
        padding: "2%",
        height: "100%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"
    },
     "w-mob": {
        boxSizing: "border-box",
        paddingBlock: "5%",
        paddingInline: "2%",
        height: "85vh",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"
    }
} as any;
export const cssProductDialogWrapperLeft = {
    "w-pc": {
        boxSizing: "border-box",
        height: "100%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"
    },
    "w-tab": {
        boxSizing: "border-box",
        height: "100%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"
    },
    "w-mob": {
        boxSizing: "border-box",
        height: "43%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"
    }
} as any
export const cssProductDialogFrame = {
    "w-pc": {
        boxSizing: "border-box",
        height: "100%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        overflow: "hidden"

    },
    "w-tab": {
        boxSizing: "border-box",
        height: "100%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        overflow: "hidden"

    },
    "w-mob": {
        boxSizing: "border-box",
        height: "90%",
        width: "60vw",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        overflow: "hidden"

    }
} as any;
export const cssProductDialogFrameImg = {
    "w-pc": {
        boxSizing: "border-box",
        height: "100%",
        // width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#b4b0b0ff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        // overflow: "hidden"

    },
    "w-tab": {
        boxSizing: "border-box",
        height: "100%",
        // width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#b4b0b0ff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        // overflow: "hidden"

    },
     "w-mob": {
        boxSizing: "border-box",
        height: "100%",
        // width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#b4b0b0ff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        objectFit: "contain"

    }
} as any;
export const cssProductDialogWrapperRight = {
    "w-pc": {
        boxSizing: "border-box",
        height: "100%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"

    },
    "w-tab": {
        boxSizing: "border-box",
        height: "100%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"

    },
    "w-mob": {
        boxSizing: "border-box",
        height: "57%",
        width: "100%",
        // border: "1px solid black",
        paddingTop: "4%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"

    }
} as any;
export const cssProductDialogDescription = {
    "w-pc": {
        boxSizing: "border-box",
        height: "100%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "start",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"

    },
    "w-tab": {
        boxSizing: "border-box",
        height: "100%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "start",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"

    },
     "w-mob": {
        boxSizing: "border-box",
        height: "100%",
        width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "start",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px"

    }
} as any;
export const cssDialogButtonClose = {
    "w-pc": {
        boxSizing: "border-box",
        height: "4vh",
        width: "4vh",
        marginBottom: "1.5vh",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        // justifySelf: "end",
        alignSelf: "end",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        overflow: "hidden"

    },
    "w-tab": {
        boxSizing: "border-box",
        height: "2vh",
        width: "2vh",
        marginBottom: "1.5vh",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        // justifySelf: "end",
        alignSelf: "end",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        overflow: "hidden"

    },
    "w-mob": {
        boxSizing: "border-box",
        height: "2.5vh",
        width: "2.5vh",
        marginBottom: "1.5vh",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        // justifySelf: "end",
        alignSelf: "end",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        overflow: "hidden"

    }
} as any;
export const cssDialogButtonCloseImg = {
    "w-pc": {
        boxSizing: "border-box",
        height: "100%",
        // width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        // backgroundColor: "#b4b0b0ff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        // overflow: "hidden"

    },
    "w-tab": {
        boxSizing: "border-box",
        height: "100%",
        // width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        // backgroundColor: "#b4b0b0ff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        // overflow: "hidden"

    },
    "w-mob": {
        boxSizing: "border-box",
        height: "100%",
        // width: "100%",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",

        // backgroundColor: "#b4b0b0ff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        // overflow: "hidden"

    }
} as any;

export const cssProductDialogTextWrapper = {
    "w-pc": {
        boxSizing: "border-box",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        overflow: "hidden"

    },
    "w-tab": {
        boxSizing: "border-box",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        overflow: "hidden"

    },
     "w-mob": {
        boxSizing: "border-box",
        // border: "1px solid black",

        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center",

        backgroundColor: "#fff",
        // boxShadow: "0 0px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        overflow: "hidden"

    }
} as any;
